<main class="tickets-page">
  <header><div><p>Customer support</p><h1>Support tickets</h1><span>Review customer requests and record resolutions.</span></div><button type="button" (click)="load()">Refresh</button></header>
  @if (error) { <div class="notice error">{{ error }}</div> }
  @if (message) { <div class="notice success">{{ message }}</div> }
  <section class="workspace">
    <div class="ticket-list">
      @if (loading) { <p>Loading tickets…</p> }
      @for (ticket of tickets; track ticket.id) {
        <button type="button" class="ticket" [class.active]="selected?.id === ticket.id" (click)="open(ticket)">
          <strong>{{ ticket.subject }}</strong><span>{{ ticket.category }} · {{ ticket.status }}</span><small>{{ ticket.createdAt }}</small>
        </button>
      } @empty { @if (!loading) { <p>No support tickets.</p> } }
    </div>
    <div class="detail">
      @if (selected) {
        <h2>{{ selected.subject }}</h2><p class="meta">Customer: {{ selected.customerUserId }} · {{ selected.category }}</p>
        <article>{{ selected.message }}</article>
        <label>Status<select [(ngModel)]="status"><option>Open</option><option>In Progress</option><option>Resolved</option><option>Closed</option></select></label>
        <label>Admin response<textarea rows="7" [(ngModel)]="response" placeholder="Resolution or reply for the customer"></textarea></label>
        <button type="button" [disabled]="saving" (click)="save()">{{ saving ? 'Saving…' : 'Update ticket' }}</button>
      } @else { <p>Select a ticket to review.</p> }
    </div>
  </section>
</main>
